import { useState, useEffect } from "react";
import { getItem, setItem } from "../utils/storageUtil";

export function usePersistentState<T>(
  storage: Storage,
  key: string,
  initialValue: T
): [T, React.Dispatch<React.SetStateAction<T>>] {
  const [value, setValue] = useState<T>(() => {
    const storedValue = getItem(storage, key);

    if (storedValue === null || storedValue === undefined) {
      return initialValue;
    } else {
      return storedValue as T;
    }
  });

  useEffect(() => {
    if (key != "") {
      setItem(storage, key, value);
    }
  }, [value, key]);

  return [value, setValue];
}
